var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[90840]) {
		innerRemote = __webpack_require__(90840);
	}
	var gs = __webpack_require__.g || globalThis
	gs["host-template"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();